import { AuditEntity } from './AuditEntity';
import { Language } from './Language';
import { Store } from './Store';

export interface Country extends AuditEntity {
  id: string;
  name: string;
  holdingTime: number;
}
export interface User extends AuditEntity {
  firstName: string;
  lastName: string;
  email: string;
  roles: Role[];
  store: Store;
  state: 'ACTIVE' | 'INACTIVE';
  country: Country;
  languages: Language[];
  blinkTimer: boolean
}

export enum UserField {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  ROLES = 'roles',
  STORE_NAME = 'store.name',
}

export enum Role {
  FRONT_OFFICE_USER = 'FRONT_OFFICE_USER',
  RESTO_ADMIN = 'RESTO_ADMIN',
  APP_ADMIN = 'APP_ADMIN',
}
